/* Routing helpers */
import {Edit} from "../pages/edit/Edit";
import {roles} from "../../../../index";
import {Details} from "../pages/details/Details";
import {List} from "../pages/list/List";
import {CONTEXT} from "./ModuleHelpers";

export const ROUTE_PREFIX = "/" + CONTEXT;

export const ROUTES = {
  new: {path: `${ROUTE_PREFIX}/new`, component: Edit, accepts: [roles.super_admin, roles.provider]},
  edit: {path: `${ROUTE_PREFIX}/:slug/edit`, component: Edit, accepts: [roles.super_admin]},
  details: {
    path: `${ROUTE_PREFIX}/:slug/details`,
    component: Details,
    accepts: [roles.super_admin, roles.client, roles.provider]
  },
  list: {
    path: `${ROUTE_PREFIX}/list`,
    component: List,
    accepts: [roles.visitor, roles.client, roles.provider, roles.super_admin]
  },
  emyServices: {path: `${ROUTE_PREFIX}/my-projects`, component: List, accepts: [roles.super_admin]},
  saved: {path: `${ROUTE_PREFIX}/saved`, component: List, accepts: [roles.super_admin]},
}
export const ROUTE_DEFAULT = ROUTES.list.path;